import ApiService from "@/core/services/api.service";

// action types
export const GET_FACTURACION_COMISION = "getFacturacionComision";
export const GET_FACTURACION_COMISION_PERIODO = "getFacturacionComisionPerido";
export const GET_REPORTE_FACTURACION_COMISION_PERIODO = "getReporteFacturacionComisionPerido";
export const GET_LIQUIDACIONES = "getLiquidaciones";
// export const SUBIR_ARCHIVO_BOLETA_FACTURA = "crearBoletaFactura";
// export const APROBAR_BOLETA_FACTURA = "aprobarBoletaFactura";
export const GET_CONCILIACION = "createOrder";
export const UPDATE_CONCILIACION = "updateConciliacion";
// export const DESCARGAR_BOLETA_FACTURA = "descargarBoletaFactura";

// mutation types
export const SET_CONCILIACIONES = "setConciliaciones";
export const SET_ORDERS = "setOrders";
export const SET_ORDER = "setOrder";
export const SET_DETAILS = "setDetails";
export const SET_ERROR = "setError";

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'

const state = {
  errors: null,
  conciliaciones: [],
  methods: [],
  orders: [],
  order: null,
};

const actions = {
  [GET_FACTURACION_COMISION](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/FacturacionComision/v1/FacturacionComision` }, "")
        .then(({ data }) => {
          // context.commit(SET_CONCILIACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_FACTURACION_COMISION_PERIODO](context, datos) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/FacturacionComision/v1/FacturacionComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.codigoAgente}` }, "")
      // Dev
    //   ApiService.get({ action: `/api/FacturacionComision/v1/FacturacionComision/${datos.rutCorredor}/${datos.mes}/${datos.anio}/${datos.codigoAgente}` }, "")
        .then(({ data }) => {
          // context.commit(SET_CONCILIACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_REPORTE_FACTURACION_COMISION_PERIODO](context, datos) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/FacturacionComision/v1/ObtenerFacturacionComisionPeriodo/${datos.mes}/${datos.anio}` }, "")
        .then(({ data }) => {
          // context.commit(SET_CONCILIACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_LIQUIDACIONES](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/liquidacion` }, "")
        .then(({ data }) => {
          context.commit(SET_CONCILIACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  // [SUBIR_ARCHIVO_BOLETA_FACTURA](context,datos) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.post({ action: `/api/facturacionComision/v1/subirArchivoBoletaFactura` },datos)
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //       .catch(({ response }) => {
  //         //console.log((response)
  //         context.commit(SET_ERROR, ""); //response.data.errors);
  //         reject(response);
  //       });
  //   });
  // },
  // [APROBAR_BOLETA_FACTURA](context,datos) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.update({ action: `/api/FacturacionComision/v1/facturacionComision` },datos.FacturacionComisionId,datos)
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //       .catch(({ response }) => {
  //         //console.log((response)
  //         context.commit(SET_ERROR, ""); //response.data.errors);
  //         reject(response);
  //       });
  //   });
  // },
  [UPDATE_CONCILIACION](context, conciliacion) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        {
          action: `/facturacioncomisionapi/api/Conciliacion/v1/conciliacion/${conciliacion.codigoConciliacion}`,
        },
        conciliacion
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  // [DESCARGAR_BOLETA_FACTURA](context, facturaComisionId) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.get({
  //       action: `/api/facturacionComision/v1/boletaFactura/${facturaComisionId}`,baseURL: url},'')
  //       .then(({ data }) => {
  //         resolve(data);
  //       })
  //       .catch(({ response }) => {
  //         reject(response);
  //       });
  //   });
  // },

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CONCILIACIONES](state, conciliaciones) {
    state.error = {};
    state.conciliaciones = conciliaciones;
  },
  [SET_ORDERS](state, orders) {
    state.error = {};
    state.orders = orders;
  },
  [SET_DETAILS](state, details) {
    state.error = {};
    state.details = details;
  },
  [SET_ORDER](state, data) {
    state.error = {};
    state.order = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
